import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhoIsFor() {
  return <section className="py-20 px-6 bg-[#1C1C2E] text-[#F5F0E8]" data-id="element-231">
      <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-232">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-233">
          <h3 className="text-2xl font-serif font-bold text-[#D4A574] mb-6" data-id="element-234">
            Es para vos si...
          </h3>
          <ul className="space-y-4" data-id="element-235">
            {['Tu hijo tiene 4–5 años (también sirve 2–8 con ajustes)', 'La noche se volvió una negociación eterna', 'Hay despertares que te dejan roto/a', 'Necesitás un sistema simple, no un curso de 10 horas'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-236">
                <div className="mt-1 w-5 h-5 rounded-full bg-[#D4A574]/20 flex items-center justify-center flex-shrink-0" data-id="element-237">
                  <Check className="w-3 h-3 text-[#D4A574]" data-id="element-238" />
                </div>
                <span className="text-[#F5F0E8]/90" data-id="element-239">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-240">
          <h3 className="text-2xl font-serif font-bold text-[#F5F0E8]/50 mb-6" data-id="element-241">
            No es para vos si...
          </h3>
          <ul className="space-y-4" data-id="element-242">
            {['Hay señales médicas importantes (ronquidos fuertes, pausas al respirar, dolor)', 'Buscás una solución mágica sin poner límites', 'No estás dispuesto/a a sostener 7 días de consistencia'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-243">
                <div className="mt-1 w-5 h-5 rounded-full bg-[#F5F0E8]/10 flex items-center justify-center flex-shrink-0" data-id="element-244">
                  <X className="w-3 h-3 text-[#F5F0E8]/50" data-id="element-245" />
                </div>
                <span className="text-[#F5F0E8]/60" data-id="element-246">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}